import { useState } from 'react';
import LoginModal from './LoginModal';

export default function LoginRequired({ onLogin }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="p5">
      <div className="p5">You need to be logged in to view this content.</div>
      <div className="p5">
        <button onClick={() => setShowModal(true)}>Log in</button>
      </div>
      { showModal && <LoginModal onClose={loggedIn => { loggedIn && typeof onLogin === "function" && onLogin(); setShowModal(false); }} /> }
    </div>
  );
}